import type React from 'react';

import { AuthToken } from '@cobliteam/api-lib/src/account/session/AuthToken';

interface PublicRouterProviderProps {
  children: React.ReactNode;
}

const PublicRouterProvider = ({ children }: PublicRouterProviderProps) => {
  const authToken = localStorage.getItem(AuthToken.ACCESS_TOKEN);
  if (authToken) return null;

  return children;
};

export default PublicRouterProvider;
